export function getPathComparator(path: string) {
  return function (routePath: string) {
    return path.startsWith(routePath) || path.startsWith(`/${routePath}`);
  };
}
